<template>
	<div class="titleBox displayItem" :class="[typeClass]">
		<span class="title"></span>
		<span class="tips"  :style="styleObj ? styleObj :''">{{ label }}</span>
		<slot name="slotBox"></slot>
	</div>
</template>

<script>
// 用法
// <dy-title label='操作教程' type="bold"></dy-title>
export default {
  name: "dy-title",
  props: {
    type: {
      type: String,
      default: "default",
    },
    label: {
      type: String,
      default: "",
    },
    styleTitleObj: {
      type: Object,
      default: null,
    }
  },
  computed: {
	typeClass() {
      if (this.type != "") {
        return `${this.type}-box`;
      } else {
        return "default-btn";
      }
    },
    styleObj(){
      return this.styleTitleObj ? this.styleTitleObj : {};
    }
  },
};
</script>

<style lang='scss' scoped>
.displayItem{
	display: flex;
	align-items: center;
}
.default-box {
	height: 32px;
	opacity: 1;
	line-height: 32px;
	.title {
		display: inline-block;
		width: 2px;
		height: 12px;
		background:  #7b61ff;
		opacity: 1;
		border-radius: 1px;
		vertical-align: middle;
		margin-right: 8px;
		font-weight: bold;
	}
	.tips {
		font-size: 14px;
		color: #1F1F1F;
		line-height: 16px;
		color: rgba(51, 51, 51, 1);
		opacity: 1;
		vertical-align: middle;
		font-weight: bold;
	}
}

.bold-box {
	height: 32px;
	opacity: 1;
	line-height: 32px;
	.title {
		display: inline-block;
		width: 2px;
		height: 14px;
		background:  #7b61ff;
		opacity: 1;
		border-radius: 1px;
		vertical-align: middle;
		margin-right: 8px;
		font-weight: bold;
	}
	.tips {
		font-size: 16px;
		color: #1F1F1F;
		line-height: 16px;
		color: #1F1F1F;
		opacity: 1;
		vertical-align: middle;
    font-weight: bold;
	}
}
.create-box {
  font-size: 16px;
  font-weight: 400;
  color: #1F1F1F;
  line-height: 22px;
  height: 22px;
  width: 100%;
  display: flex;
  align-items: center;
  .title {
    width: 4px;
    height: 16px;
    background: #7b61ff;
    border-radius: 0px 3px 3px 0px;
    margin-right: 8px;
  }
}
.bg-box {
  background: #F7F8FA;
  border-radius: 2px 2px 2px 2px;
  padding: 8px;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  .title {
    width: 2px;
    height: 14px;
    background: #7b61ff;
    border-radius: 1px 1px 1px 1px;
    margin-right: 8px;
  }
}
</style>